import React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

const CustomSelectField = ({
  margin,
  onChange,
  value,
  defaultValues,
  title,
  id,
  disabled,
  required,
}) => {
  const handleChange = (event) => {
    onChange(event.target.value);
  };
  return (
    <FormControl fullWidth margin={margin} disabled={disabled}>
      <InputLabel
        required={required}
        variant="filled"
        id={id + "-select-label"}
      >
        {title}
      </InputLabel>
      <Select
        labelId={id + "-select-label"}
        id={id + "-select"}
        value={value || ""}
        label={title}
        variant="filled"
        onChange={handleChange}
      >
        {defaultValues.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSelectField;
